module.exports = __webpack_public_path__ + "img/rob-pro.b93a087c.jpg";